export const ValueChanged = 'destinationField/valueChanged';
export const FunctionValueChanged = 'destinationField/functionValueChanged';
export const ResetClicked = 'destinationField/resetClicked';
export const InputChanged = 'destinationField/inputChanged';
export const CloseClicked = 'destinationField/CloseClicked';
export const PromotionClicked = 'destinationField/PromotionClicked';